import type { LocaleConfig } from '@src/i18n/locales'

/**
 * Last match wins: while streaming, the fresh tag can land in <body> while a
 * stale one lingers in <head>, and tags may not be hoisted to <head> yet.
 */
export function readAlternateHref(
  hreflang: string,
  doc: Document | undefined = globalThis.document
): string | null {
  const tags = doc?.querySelectorAll(`[rel="alternate"][hreflang="${hreflang}"]`)
  const last = tags?.[tags.length - 1]
  return last?.getAttribute('href') ?? null
}

interface GetLocaleSwitchHrefArgs {
  /** Current window.location.search (leading '?' included, or ''). */
  search: string
  origin: string
  targetLocale: LocaleConfig
  /** hreflang href read from the document for the target locale, or null. */
  alternateHref: string | null
}

/** Without an alternate tag, the page has no known equivalent, so use the locale's landing path and drop search. */
export function getLocaleSwitchHref({
  search,
  origin,
  targetLocale,
  alternateHref,
}: GetLocaleSwitchHrefArgs): string {
  const fallbackUrl = `${origin}${targetLocale.path}${targetLocale.fallbackPath}`
  const url = new URL(alternateHref ?? fallbackUrl, origin)
  url.search = alternateHref ? search : ''
  return url.toString()
}
